import React from "react";
import { Grid, withStyles, Checkbox } from "@material-ui/core";

const styles = (theme) => ({
  safetyInfo: {
    fontSize: theme.textFontSize,
    lineHeight: "19px",
    color: theme.errorBorderColor,
    padding: "3px 20px",
    wordBreak: "break-word",
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.textFontSize,
    padding: "0px 15px",
  },
  root: {
    color: theme.checkboxColor,
    padding: "5px",
  },
  checkboxLabel: {
    fontWeight: 400,
    color: theme.radioLabelText
  }
});

const SafetyData = ({ classes, safetyData, isOK, onIsOKCLick }) => {
  return (
    <Grid container>
      {safetyData?.map((safetyInfo, index) => (
        <div
          className={classes.safetyInfo}
          key={`safetyInfo-${index}`}
        >{safetyInfo.message}</div>
      ))}
      <div className={classes.checkboxContainer}>
        <Checkbox
          classes={{
            root: classes.root,
          }}
          color="primary"
          onChange={onIsOKCLick}
          checked={isOK}
        />
        <span className={classes.checkboxLabel}>OK</span>
      </div>
    </Grid>
  );
};

export default withStyles(styles)(SafetyData);
